// Keep in sync with backend/utils/readingStory.js: Enter defines a Story unit.
// Visual wrapping and punctuation never create extra practice/audio items.
export function splitReadingStoryLines(text) {
  return String(text || '').split(/\r\n|\r|\n/).map(line => line.trim()).filter(Boolean);
}
